export const state = {
  filterParameter: {
    name: "",
    isFilter: false
  }
};
export const mutations = {
  ADD_FILTER_PARAMETER: (state, data) => {
    state.filterParameter = data;
    state.filterParameter.isFilter = true;
  },
  CLEAR_FILTER_PARAMETER: (state) => {
    state.filterParameter = {
      name: ""
    };
  },
};
export const getters = {
  GET_FILTER_PARAMETER: (state) => {
    // console.log("GET_FILTER_PARAMETER", state.filterParameter);
    return state.filterParameter;
  },
};
export const actions = {
  ADD_FILTER_PARAMETER: ({ commit }, data) => {
    commit("ADD_FILTER_PARAMETER", data);
  },
  CLEAR_FILTER_PARAMETER: ({ commit }) => {
    commit("CLEAR_FILTER_PARAMETER");
  },
};
